import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './BalanceCardView';

export default withErrorWrapper(view);
